// ./core/UI/overlayelements/ConnectionStatusOverlay.styles.ts
import React from 'react';

/**
 * Defines the CSS keyframes for the spinner animation as a string.
 * This can be injected into a <style> tag within the component.
 */
export const keyframes = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

/**
 * An object containing all the CSS styles for the ConnectionStatusOverlay component.
 */
export const styles: { [key: string]: React.CSSProperties } = {
  overlayStyle: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    zIndex: 100000,
    fontFamily: "'Inter', system-ui, sans-serif",
    pointerEvents: 'auto',
    // backdropFilter: 'blur(5px)',
  },
  spinnerStyle: {
    border: '4px solid rgba(255, 255, 255, 0.3)',
    borderTop: '4px solid #fff',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
  },
  textStyle: {
    marginTop: '20px',
    fontSize: '22px',
    fontWeight: 600,
  },
  subTextStyle: {
    marginTop: '8px',
    fontSize: '16px',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  buttonStyle: {
    marginTop: '24px',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#28A745',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
};
